<template>
  <div v-if="customIsVisible" :class="[backgroundColor, bottomMargin, verticalPadding]" class="login">
    <!-- Innovadis custom: pass title and heading from component settings -->
    <LoginFormSection :title="title" :heading="heading" />
  </div>
</template>

<script setup lang="ts">
import { LoginFormSection } from "@/shared/layout";

defineProps<{
  id: string; // Innovadis custom
  heading?: string; // Innovadis custom
  title?: string; // Innovadis custom

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: Record<string, any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  settings: Record<string, any>;

  // Innovadis custom: Use custom visibility setting
  customIsVisible: boolean;

  // Innovadis custom: Use custom layout settings
  backgroundColor: string;
  bottomMargin: string;
  verticalPadding: string;
}>();
</script>
